import { WifiOff, RefreshCw } from 'lucide-react';
import { useOfflineQueue } from '@/hooks/useOfflineQueue';

export function OfflineIndicator() {
  const { pendingCount, isOnline, isSyncing } = useOfflineQueue();

  // Only show when offline OR when syncing queued items
  if (isOnline && !isSyncing && pendingCount === 0) return null;

  return (
    <div
      className={[
        'fixed bottom-16 sm:bottom-0 left-0 right-0 z-50',
        'flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white',
        isSyncing ? 'animate-pulse' : '',
      ].join(' ')}
      style={{ backgroundColor: '#E67E22' }}
      role="status"
      aria-live="polite"
    >
      {isSyncing ? (
        <>
          <RefreshCw className="h-4 w-4 animate-spin" aria-hidden="true" />
          <span>Synchronisation en cours...</span>
        </>
      ) : (
        <>
          <WifiOff className="h-4 w-4" aria-hidden="true" />
          <span>
            Hors ligne
            {pendingCount > 0 &&
              ` \u2014 ${pendingCount} action${pendingCount > 1 ? 's' : ''} en attente`}
          </span>
        </>
      )}
    </div>
  );
}
